import React from 'react';
import {
    toStr,
    isStarterEntry,
    lineupPlayerKey,
    getLineupPlayerProfile,
    getOnFieldPlayers,
    getBenchPlayers,
    getSubbedOutIds,
    getSubbedInIds,
    rosterEntryKey,
} from '../../utils/tickerLineupUtils';

function SquadList({ title, players, getNum, onPlayerClick, activeFlow, teamId, highlightId }) {
    if (!players.length) return null;

    return (
        <div className="ticker-squad-group">
            <p className="ticker-squad-group-title">{title}</p>
            <div className="ticker-squad-list">
                {players.map((entry) => {
                    const key = lineupPlayerKey(entry);
                    const profile = getLineupPlayerProfile(entry);
                    const num = getNum(key) || entry.num || profile.num;
                    const name = profile.surname || '?';
                    const isActive = highlightId === key;
                    return (
                        <button
                            key={key}
                            type="button"
                            className={`ticker-squad-row ${isActive ? 'ticker-squad-row--active' : ''}`}
                            onClick={() => onPlayerClick?.({ playerKey: key, teamId })}
                            disabled={!activeFlow && !onPlayerClick}
                        >
                            <span className="ticker-squad-num">{num || '–'}</span>
                            <span className="ticker-squad-name">{name}</span>
                            {!isStarterEntry(entry) && <span className="ticker-squad-tag">Bank</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export default function TickerSquadPanel({
    game,
    lineup,
    events,
    availablePlayers,
    activeFlow,
    onPlayerPick,
    onClose,
}) {
    const homeId = toStr(game?.hid?._id || game?.hid);
    const awayId = toStr(game?.aid?._id || game?.aid);
    const homeName = game?.hid?.name || 'Heim';
    const awayName = game?.aid?.name || 'Gast';

    const getNum = (key) => {
        const pt = availablePlayers?.find((p) => rosterEntryKey(p) === toStr(key));
        return pt?.num || '';
    };

    const renderTeam = (teamId, teamName, prefix) => {
        const onField = getOnFieldPlayers(lineup, teamId, getSubbedOutIds(events, teamId));
        const bench = getBenchPlayers(lineup, teamId, getSubbedInIds(events, teamId));

        return (
            <div className="ticker-squad-team">
                <h3 className="ticker-squad-team-name">{prefix} {teamName}</h3>
                <SquadList
                    title="Auf dem Feld"
                    players={onField}
                    getNum={getNum}
                    teamId={teamId}
                    activeFlow={activeFlow}
                    onPlayerClick={activeFlow ? onPlayerPick : null}
                />
                <SquadList
                    title="Bank"
                    players={bench}
                    getNum={getNum}
                    teamId={teamId}
                    activeFlow={activeFlow}
                    onPlayerClick={activeFlow ? onPlayerPick : null}
                />
            </div>
        );
    };

    return (
        <aside className="ticker-squad-panel">
            <div className="ticker-squad-head">
                <h2>Kader</h2>
                <button type="button" className="ticker-action-icon" onClick={onClose} title="Panel schließen">✕</button>
            </div>
            {activeFlow && (
                <p className="ticker-squad-hint">Spieler antippen für {activeFlow}</p>
            )}
            {renderTeam(homeId, homeName, '🏠')}
            {renderTeam(awayId, awayName, '✈️')}
        </aside>
    );
}
